import { Component, OnInit } from '@angular/core';
import { Observable, Subject, timer, EMPTY } from 'rxjs';
import { VwTrt24DirfOpseTransporte } from '../_classes/vw-trt24-dirf-opse-transporte';
import { MatTableDataSource } from '@angular/material/table';
import { RestService } from '../_servicos/rest.service';
import { ModalAlertaService } from '../shared/modal-alerta.service';
import { ServidorService } from '../_servicos/servidor.service';
import { ModalAjudaService } from '../shared/modal-ajuda.service';
import { tap, take, catchError } from 'rxjs/operators';
import { Util } from '../_classes/util';
import { EnvService } from '../_servicos/env.service';
import { UtilLogAcessoSistema } from '../_classes/util-log-acesso-sistema';

@Component({
  selector: 'app-operadora-sem-ans',
  templateUrl: './operadora-sem-ans.component.html',
  styleUrls: ['./operadora-sem-ans.component.scss'],
})
export class OperadoraSemAnsComponent implements OnInit {
  private readonly recurso: string = 'desconto-dirf';
  carregando = false;
  displayedColumns: string[] = [
    'dirf.nrAnoReferencia',
    'dsNomeOperadora',
    'dependente.dsNomeDependente',
    'valor',
  ];

  //servidor$: Observable<Servidor>;
  //servidor: Servidor = new Servidor();

  erros$ = new Subject<boolean>();
  dataSource$: Observable<VwTrt24DirfOpseTransporte[]>;
  dataSource: MatTableDataSource<VwTrt24DirfOpseTransporte>;

  itensAjuda = [
    {
      titulo: 'Referência',
      texto: 'Ano referência da DIRF (posterior ao ano-calendário).',
    },
    {
      titulo: 'Dependente',
      texto: 'Nome do dependente',
    },
    {
      titulo: 'Operadora',
      texto: 'Nome da operadora',
    },
    {
      titulo: 'Valor',
      texto: 'Valor pago à operadora',
    },
  ];

  private t: any;

  spanningColumns = [
    'dirf.nrAnoReferencia',
    'dsNomeOperadora',
    'dependente.dsNomeDependente',
  ];
  spans = [];
  DATA: VwTrt24DirfOpseTransporte[];

  ngOnDestroy() {
    if (this.t) {
      this.t.unsubscribe();
    }
  }

  constructor(
    private service: RestService,
    private servService: ServidorService,
    private alertService: ModalAlertaService,
    private ajudaService: ModalAjudaService,
    private env: EnvService
  ) {}

  ngOnInit() {
    this.atualizar();
  }
  /*
  executarAoCarregarServidor(x: Servidor) {
    this.servidor = new Servidor(x);
  }


  */

  executarAoCarregarDatasource(x: VwTrt24DirfOpseTransporte[]) {
    this.dataSource = new MatTableDataSource<VwTrt24DirfOpseTransporte>(x);
    this.DATA = x;
    this.spanRow('dirf.nrAnoReferencia', (d) => d.dirf.nrAnoReferencia);
    this.spanRow('dsNomeOperadora', (d) => d.dsNomeOperadora);
    this.dataSource.sortingDataAccessor = this.sortingDataAccessor;

    this.carregando = false;
    this.unsubscribeAll();
  }

  unsubscribeAll() {
    if (this.t) {
      this.t.unsubscribe();
    }
  }

  spanRow(key, accessor) {
    for (let i = 0; i < this.DATA.length; ) {
      let currentValue = accessor(this.DATA[i]);
      let count = 1;

      // Iterate through the remaining rows to see how many match
      // the current value as retrieved through the accessor.
      for (let j = i + 1; j < this.DATA.length; j++) {
        if (currentValue != accessor(this.DATA[j])) {
          break;
        }

        count++;
      }

      if (!this.spans[i]) {
        this.spans[i] = {};
      }

      // Store the number of similar values that were found (the span)
      // and skip i to the next unique row.
      this.spans[i][key] = count;
      i += count;
    }
  }

  getRowSpan(col, index) {
    return this.spans[index] && this.spans[index][col];
  }

  sortingDataAccessor(item, property) {
    if (property.includes('.')) {
      return property.split('.').reduce((object, key) => object[key], item);
    }
    return item[property];
  }

  atualizar() {
    this.carregando = true;
    this.t = timer(20000).subscribe((v) => {
      if (this.carregando) {
        this.carregando = false;
        this.handleError(
          'Excedido tempo de carregamento (' + this.constructor.name + ')'
        );
      }
    });
    if (this.env.servidor) {
      this.listar();
    } else {
      //this.servService.getServidorComFuncao(() => {this.listar();});
      this.servService.getServidorComFuncao2().then(() => this.listar());
    }
  }

  listar() {
    UtilLogAcessoSistema.registrarAcessoAoRecurso(
      this.recurso,
      this.env.servidor.idServidor,
      this.service
    );
    this.dataSource$ = this.service
      .listarDirfOpseTransporte(this.env.servidor.idServidor)
      .pipe(
        tap((a) => this.executarAoCarregarDatasource(a)),
        take(1),
        catchError((e) => {
          this.handleError(e);
          return EMPTY;
        })
      );
  }

  periodo(dI: Date, dF: Date) {
    return Util.periodoMesAbreviado(dI, dF);
  }
  dataStr(d: Date) {
    return Util.dataMesAbrev(d);
  }

  mostrarAjudaModal() {
    this.ajudaService.mostrar(this.itensAjuda, '');
  }

  handleError(e: any) {
    this.erros$.next(true);
    this.alertService.mostrarAlertaPerigo(
      'Erro, tente novamente mais tarde',
      e
    );
  }
}
